import React from "react";

import LoginPage from "components/Login/LoginPage";
import logo_login from "images/custom/logo_login.png";

import {
  ENABLE_LOGIN_TOPBAR,
  ENABLE_LOGIN_HOME,
  ENABLE_REGISTER_PAGES,
  ENABLE_TOUR_PUBLIC,
} from "config";
import urlServices from "services/urlServices";
import deviceServices from "services/deviceServices";
import "./LoginPage.css";

/**
 * CUSTOM for Team Comply
 * Login Page
 */
class CustomLoginPage extends LoginPage {
  /**
   * Render logo segment
   */
  renderProjectBranding() {
    return (
      <div>
        {/* Logo */}
        <p>
          <img src={logo_login} alt="Logo" className="imgresponsive" />
        </p>
      </div>
    );
  }

  /**
   * Render the custom login page
   */
  render() {
    if (
      /* checking type is important: showPrivacyAgreement is initialised as null */
      typeof this.props.showPrivacyAgreement === "boolean" &&
      this.props.showPrivacyAgreement === true
    ) {
      // P&G is unlikely to use this, so just use defaults.
      return super.render();
    } else {
      // Render standard login page
      return (
        <div className="login-register-container container verticalpadding">
          {this.renderTopbarlessBackButton()}
          <div
            className={
              "innerblock pure-g" +
              (ENABLE_LOGIN_HOME && !ENABLE_LOGIN_TOPBAR ? " topmargin-20" : "")
            }
          >
            <div className="pure-u-md-4-24" />
            <div className="pure-u-1 pure-u-md-16-24">
              {this.renderProjectBranding()}

              <div className="pure-g">
                <div className="pure-u-1-1 pure-u-sm-1-12" />
                <div className="pure-u-1-1 pure-u-sm-5-6">
                  <form
                    className="pure-form"
                    onSubmit={this.handlePreSubmit.bind(this)}
                  >
                    {this.renderLoginFields()}
                    {this.renderGuestLoginSection()}
                  </form>
                  {/* Add hidesso=true to query string in order to hide sso login, e.g. /login?hidesso=true */}
                  {urlServices.getUrlParamValueByKey("hidesso") !== "true" &&
                    !deviceServices.isWebView() &&
                    this.renderSSOLoginSection()}
                  {ENABLE_REGISTER_PAGES && this.renderRegisterSection()}
                  {ENABLE_TOUR_PUBLIC && this.renderTourLink()}
                </div>
              </div>
            </div>
            <div className="pure-u-md-4-24" />
          </div>
          {this.state.showTourModal && this.renderTourModal()}
        </div>
      );
    }
  }
}

export default CustomLoginPage;
